<template>
  <div class="relative">
    <HeroImage v-if="image" :image="image" class="">
      <div class="flex items-center h-full">
        <div class="lg:pl-12 md:block md:w-8/12 lg:w-[55%] z-10 hidden pl-4">
          <div class="box w-full">
            <slot name="boxDesktop"></slot>
          </div>
        </div>
      </div>
      <slot name="imageOverlay"></slot>
    </HeroImage>
    <div class="md:hidden box block">
      <slot name="boxMobile"></slot>
    </div>
  </div>
</template>

<script>
import HeroImage from '@/components/common/HeroImage';
export default defineNuxtComponent({
  components: {
    HeroImage,
  },
  props: {
    image: {
      type: Object,
      default: () => null,
    },
  },
});
</script>
